export default from './demote-moderator-modal';



// WEBPACK FOOTER //
// ./app/containers/demote-moderator-modal/index.js